export enum FileMacroTypeEnum {

  TESSERINO_FIN = 4,
  PARENT_DOCUMENT = 2

}
